module.exports = __webpack_public_path__ + "static/media/conference-catering-4.94e6b703.jpg";